import { render } from "./TransportCostList.vue?vue&type=template&id=78046056&scoped=true&ts=true"
import script from "./TransportCostList.vue?vue&type=script&lang=ts"
export * from "./TransportCostList.vue?vue&type=script&lang=ts"

import "./TransportCostList.vue?vue&type=style&index=0&id=78046056&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78046056"]])

export default __exports__